import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueMaterial from 'vue-material'
import VueRouter from "vue-router"
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import firebase from "firebase/app";
import 'firebase/analytics'

const baseUrl = 'http://dorbom.com/';
const Common = require("./common");

const firebaseConfig = {
  apiKey: "AIzaSyDjmOe9H5zP-1M6hATFWdNetNFeyUPHSnE",
  authDomain: "tracking-aad5c.firebaseapp.com",
  databaseURL: "https://tracking-aad5c.firebaseio.com",
  projectId: "tracking-aad5c",
  storageBucket: "tracking-aad5c.appspot.com",
  messagingSenderId: "585149834100",
  appId: "1:585149834100:web:ab9061bafcd86d0fb30221",
  measurementId: "G-GT69PEFYV9"
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

Vue.config.productionTip = false;
Vue.prototype.$common = Common;
Vue.prototype.$http = axios;
Vue.prototype.$http.defaults.baseURL = baseUrl;

Vue.use(VueRouter);
Vue.use(VueMaterial)

const router = new VueRouter({

  mode: 'abstract',
  routes: [
    {
      path: '/',
      component: () => import("@/components/main")
    }
  ],
  scrollBehavior(to, from) {
    from

    if (from.path.length <= to.path.length) {
      return {x: 0, y: 0};
    }
  }
});

new Vue({
  render: h => h(App),
  router
}).$mount('#app')

router.replace('/');